import { ListItemButton, Typography } from '@mui/material';

import { getPatients } from 'apis/admin';
import usePatient from 'store/patient/usePatient';
import MuiAutocomplete from 'components/MuiAutocomplete';

import { ReactComponent as Empty } from 'assets/alarm-icon-empty.svg';

interface IOption {
  patient_id: string;
  patient_virtual_id?: string;
  name: string;
  age: string;
}

interface Props {
  user_id: number;
}

const PatientsList = ({ user_id }: Props) => {
  const { onSelectedPatient } = usePatient();

  const optionLabel = ({ patient_id, patient_virtual_id, name }: IOption) =>
    `${patient_virtual_id || patient_id} ${name}`;

  // 항목마다 간호기록을 부르던 코드는 지웠다. 의존성 없는 useEffect 라 드롭다운이 열려 있는 동안
  // 그려진 항목마다 끝없이 다시 불렀고, 아이콘은 오류 응답이 아니면 늘 Empty 였다 (ENR-BUGFIX-115)
  const Option = ({ patient_id, patient_virtual_id, name, age, ...props }: IOption) => {
    const displayPatientId = patient_virtual_id || patient_id;

    return (
      <ListItemButton {...props} sx={{ gap: 0.2 }}>
        <Empty />
        <Typography
          variant="subtitle2"
          fontSize="14px"
          sx={{ whiteSpace: 'nowrap' }}
        >
          {displayPatientId}
        </Typography>
        <Typography variant="caption" fontSize="14px" color={'#000000B2'}>
          {name}
        </Typography>
        <Typography
          variant="caption"
          fontSize="14px"
          color={'#000000B2'}
          sx={{ whiteSpace: 'nowrap' }}
        >
          {age}
        </Typography>
      </ListItemButton>
    );
  };

  return (
    <MuiAutocomplete
      syncWithPatient
      autoSelectFirst
      variant="standard"
      valueKey="patient_id"
      listKey="admin_patients"
      placeholder="환자 검색"
      noOptionsText="No patient found. Please enter another patient name"
      getOptionLabel={optionLabel}
      renderOption={(props, option) => {
        if (!user_id) {
          return null;
        } else return <Option {...props} {...option} />;
      }}
      onChange={onSelectedPatient}
      getApi={params => getPatients({ ...params, user_id })}
    />
  );
};

export default PatientsList;
